/** @jsx jsx */
import { Box, jsx } from "theme-ui";
import React, { useEffect, useState } from "react";
import builder from "@builder.io/react";
import Button from "../../components/buttons/Button";


/**
 * a wrapper for the button to handle links
 */
export type BuilderButtonProps = {
  page: any;
  link?: string;
  label: string;
  variant: string;
  openInNewTab: boolean;
};
export const BuilderButton: React.FC<BuilderButtonProps> = ({
  link = "",
  label,
  variant,
  page,
  openInNewTab = false,
}) => {
  const [linkedPage, setLinkedPage] = useState<string>("");

  useEffect(() => {
    //console.log("page", page);
    if (!page) return;
    builder
      .get("page", {
        options: { noTargeting: true },
        query: { id: page.id },
        fields: "data.url",
      })
      .promise()
      .then((result) => {
        //console.log("res", result.data.url);
        setLinkedPage(result.data.url);
      })
      .catch((err) => console.log(err));
  }, []);

  //console.log(page);

  return (
    <Box>
      <Button
        internallink={linkedPage || link || "/"}
        externallink={linkedPage || link || "/"}
        label={label}
        template={"Default"}
        variant={variant || "Primary"}
        openInNewTab={openInNewTab}
      />
    </Box>
  );
};

export default BuilderButton;
